import { useState } from "react";
import { BrandShell } from "../components/BrandShell";
import { goToCamp } from "../lib/route";

export function CampCodePage() {
  const [code, setCode] = useState("");

  function submit(
    event: React.FormEvent
  ) {
    event.preventDefault();

    const slug = code
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "");

    if (slug) {
      goToCamp(slug);
    }
  }

  return (
    <BrandShell eyebrow="Multi-camp platform">
      <p className="lead">
        Enter the camp code supplied by
        your administrator.
      </p>

      <form onSubmit={submit}>
        <label>
          Camp code
          <input
            value={code}
            onChange={(event) =>
              setCode(event.target.value)
            }
            placeholder="frontier-overnight"
            autoComplete="organization"
          />
        </label>

        <button type="submit">
          Continue
        </button>
      </form>
    </BrandShell>
  );
}
